import { render } from "./ModalSameKeyContact.vue?vue&type=template&id=e319793c&scoped=true"
import script from "./ModalSameKeyContact.vue?vue&type=script&lang=js"
export * from "./ModalSameKeyContact.vue?vue&type=script&lang=js"

import "./ModalSameKeyContact.vue?vue&type=style&index=0&id=e319793c&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e319793c"]])

export default __exports__